<template>
    <div class="bordas botoes-validar">
        <button type="button" class="btn btn-primary btn-sm btn-validar font-weight-bold" @click="valida()"> 
            Validar
        </button>
    </div>
</template>

<script>
export default {
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        }
    },
    methods: {
        valida () {
            this.$store.dispatch('leitos/registraValidacao', {cnes: this.unidadeSelecionada.cnes.toString()})
        }
    }
}
</script>


<style>
    .botoes-validar {
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
    }

    .btn-validar {
        min-width: 125px;
    }

    @media (min-width: 1154px) {
        .botoes-validar {
            flex-direction: column;
        }
    }
</style>